import { useState } from 'react';
import { Modal, TextInput, ScrollArea } from '@mantine/core';
import { IconChevronRight, IconSearch } from '@tabler/icons-react';

import RessourceOptions from './RessourcesOptions';

// Regroupe les options par catégorie, dans l'ordre d'apparition du fichier source
const GROUPED_OPTIONS = RessourceOptions.reduce((groups, option) => {
    const group = groups.find(g => g.name === option.group);
    if (group) {
        group.items.push(option);
    } else {
        groups.push({ name: option.group, items: [option] });
    }
    return groups;
}, []);

// Sélecteur de catégorie de ressource : modal plein écran avec catégories bien
// visibles (liste très longue), identique sur mobile et desktop.
const ResourceCategorySelect = ({ value, onChange, error, label = "Catégorie", placeholder = "Sélectionnez" }) => {
    const [modalOpened, setModalOpened] = useState(false);
    const [search, setSearch] = useState("");

    const selectedOption = RessourceOptions.find(o => o.value === value);
    const normalizedSearch = search.trim().toLowerCase();
    const filteredGroups = GROUPED_OPTIONS
        .map(group => ({
            ...group,
            items: group.items.filter(item => item.label.toLowerCase().includes(normalizedSearch)),
        }))
        .filter(group => group.items.length > 0);

    const handleSelect = (optionValue) => {
        onChange(optionValue);
        setModalOpened(false);
        setSearch("");
    };

    return (
        <>
            <TextInput
                label={label}
                placeholder={placeholder}
                withAsterisk
                readOnly
                value={selectedOption?.label || ""}
                error={error}
                onClick={() => setModalOpened(true)}
                rightSection={<IconChevronRight size={16} />}
                styles={{
                    input: { color: 'black', fontWeight: 600, cursor: 'pointer' },
                    placeholder: { fontWeight: 600 },
                }}
            />

            <Modal
                fullScreen
                opened={modalOpened}
                onClose={() => { setModalOpened(false); setSearch(""); }}
                title="Sélectionnez une catégorie"
                styles={{ title: { fontWeight: 700, fontSize: 18 } }}
            >
                <TextInput
                    placeholder="Rechercher une catégorie..."
                    value={search}
                    onChange={(e) => setSearch(e.currentTarget.value)}
                    leftSection={<IconSearch size={16} />}
                    mb="md"
                />

                <ScrollArea style={{ height: 'calc(100vh - 160px)' }}>
                    {filteredGroups.length === 0 ? (
                        <p className="dGreyT txtCenter mrgT30">Aucune catégorie trouvée</p>
                    ) : (
                        filteredGroups.map(group => (
                            <div key={group.name} style={{ marginBottom: 20 }}>
                                <p style={{
                                    fontSize: 15,
                                    fontWeight: 800,
                                    color: '#2e7d32',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    marginBottom: 8,
                                    paddingBottom: 6,
                                    borderBottom: '2px solid #2e7d32',
                                }}>
                                    {group.name}
                                </p>
                                {group.items.map(item => (
                                    <button
                                        key={item.value}
                                        type="button"
                                        onClick={() => handleSelect(item.value)}
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            textAlign: 'left',
                                            border: 'none',
                                            background: item.value === value ? '#f1f8f2' : 'transparent',
                                            padding: '14px 10px',
                                            fontSize: 15,
                                            fontWeight: item.value === value ? 700 : 500,
                                            color: '#1c1c1c',
                                            borderRadius: 8,
                                        }}
                                    >
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                        ))
                    )}
                </ScrollArea>
            </Modal>
        </>
    );
};

export default ResourceCategorySelect;
